import { render, staticRenderFns } from "./VW.vue?vue&type=template&id=301511b4&"
import script from "./VW.vue?vue&type=script&lang=js&"
export * from "./VW.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports